<template>
  <div class="dpn" :class="$theme.darkTheme ? 'dpn--dark' : 'dpn--light'">
    <div class="dpn__icon-wrap">
      <div class="dpn__icon-bg">
        <i class="material-icons dpn__icon">warning</i>
      </div>
    </div>

    <div class="dpn__body">
      <h3 class="dpn__title">Acesso offline alterado</h3>
      <p v-if="courseName" class="dpn__course-name">{{ courseName }}</p>
      <p class="dpn__desc">
        O produtor desabilitou o download de aulas deste curso.
        <br />
        <strong>{{ loCount }}</strong>
        {{ loCount === 1 ? "aula baixada será removida" : "aulas baixadas serão removidas" }}
        deste dispositivo para que você possa continuar.
      </p>
      <p v-if="error" class="dpn__error">{{ error }}</p>
    </div>

    <div class="dpn__actions">
      <button class="dpn__btn dpn__btn--remove" :disabled="removing" @click="confirm">
        <span v-if="removing" class="dpn__spinner"></span>
        <i v-else class="material-icons dpn__btn-icon">{{ error ? "refresh" : "delete_outline" }}</i>
        {{ buttonLabel }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "DrmPurgeNotice",
  props: {
    courseName: { type: String, default: "" },
    loCount: { type: Number, default: 0 },
  },
  data() {
    return {
      removing: false,
      error: null,
    };
  },
  computed: {
    buttonLabel () {
      if (this.removing) return 'Removendo...';
      if (this.error) return 'Tentar novamente';
      return 'Remover downloads e continuar';
    }
  },
  mounted() {
    document.body.classList.add('drm-purge-modal-open');
  },
  beforeDestroy() {
    document.body.classList.remove('drm-purge-modal-open');
  },
  methods: {
    async confirm() {
      if (this.removing) return;
      this.removing = true;
      this.error = null;
      try {
        await this.$store.dispatch("download/executePendingDrmPurge");
        this.$emit("close");
      } catch (err) {
        console.error('[DrmPurgeNotice] purge failed:', err);
        // Mantém modal aberto pra retry. removeAllFromEnroll é idempotente
        // (LOs já removidos viram no-op no segundo passo).
        this.error = 'Não foi possível remover alguns downloads. Tente novamente.';
        this.removing = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.dpn {
  padding: 28px 24px 24px;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  &--light {
    background: #ffffff;
    color: #1a1a2e;

    .dpn__title {
      color: #1a1a2e;
    }
    .dpn__course-name {
      color: #555;
    }
    .dpn__desc {
      color: #666;
    }
  }

  &--dark {
    background: #16161f;
    color: #f0f0f0;

    .dpn__title {
      color: #f0f0f0;
    }
    .dpn__course-name {
      color: #a0a0b0;
    }
    .dpn__desc {
      color: #b0b0c0;
    }
  }
}

.dpn__icon-wrap {
  margin-bottom: 20px;
}

.dpn__icon-bg {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: rgba(239, 68, 68, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
}

.dpn__icon {
  font-size: 28px;
  color: #ef4444;
}

.dpn__body {
  margin-bottom: 28px;
}

.dpn__title {
  font-family: "Montserrat", Roboto, sans-serif;
  font-size: 17px;
  font-weight: 700;
  margin: 0 0 8px;
  line-height: 1.3;
}

.dpn__course-name {
  font-size: 13px;
  font-weight: 500;
  margin: 0 0 12px;
  padding: 4px 12px;
  border-radius: 20px;
  display: inline-block;
  background: rgba(239, 68, 68, 0.08);
  color: #ef4444;
  max-width: 280px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dpn__desc {
  font-size: 13px;
  line-height: 1.55;
  margin: 0;
  padding: 0 4px;
}

.dpn__error {
  font-size: 12px;
  font-weight: 500;
  line-height: 1.45;
  margin: 14px 0 0;
  padding: 8px 12px;
  border-radius: 8px;
  background: rgba(239, 68, 68, 0.12);
  color: #ef4444;
}

.dpn__actions {
  display: flex;
  width: 100%;
}

.dpn__btn {
  flex: 1;
  height: 48px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  font-family: "Montserrat", Roboto, sans-serif;
  cursor: pointer;
  border: none;
  outline: none;
  transition: opacity 0.15s ease, background 0.15s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;

  &:active:not(:disabled) {
    opacity: 0.85;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.7;
  }
}

.dpn__btn-icon {
  font-size: 18px;
  line-height: 1;
}

.dpn__btn--remove {
  background: #ef4444;
  color: #fff;
  box-shadow: 0 4px 14px rgba(239, 68, 68, 0.35);

  &:hover:not(:disabled) {
    background: #dc2626;
  }
}

.dpn__spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.35);
  border-top-color: #fff;
  border-radius: 50%;
  animation: dpn-spin 0.7s linear infinite;
}

@keyframes dpn-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
